import React from 'react'


const HorizontalRule = () => (
    <hr className='border-solid border-bottom-2 border-base-200 border-opacity-20 my-6 mt-12 mx-auto' style={{ width: '98%' }} />
)

export default HorizontalRule
